import axios from "axios";

import { BACKEND_URL } from "../constants"

const listGuidance = () => {
  const url = `${BACKEND_URL}/api/v1/clifton-strengths/guidance/s/`;
  return axios.get(url);
}

const updateGuidance = (file) => {
  const url = `${BACKEND_URL}/api/v1/clifton-strengths/guidance/s/`;
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(url, formData);
}

const listReports = (startDate, endDate) => {
  const params = new URLSearchParams([
    ["start_date", startDate.toISOString()],
    ["end_date", endDate.toISOString()],
  ]);
  const url = `${BACKEND_URL}/api/v1/clifton-strengths/reports/s/`;
  return axios.get(url, { params });
}

const validateReport = (file) => {
  const url = `${BACKEND_URL}/api/v1/clifton-strengths/reports/s/`;
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(url, formData);
}

const retrieveReport = (reportId) => {
  const url = `${BACKEND_URL}/api/v1/clifton-strengths/reports/${reportId}/`;
  return axios.get(url);
}

const processReport = (reportId) => {
  const url = `${BACKEND_URL}/api/v1/clifton-strengths/reports/${reportId}/s/`;
  return axios.post(url);
}

const listAssessmentReportTemplates = () => {
  const url = `${BACKEND_URL}/api/v1/clifton-strengths/assessment-reports/templates/s/`;
  return axios.get(url);
}

const createAssessmentReportPreview = (reportId, templateId) => {
  const url = `${BACKEND_URL}/api/v1/clifton-strengths/assessment-reports/previews/s/`;
  return axios.post(
    url,
    {
      report_id: reportId,
      template_id: templateId,
    },
  );
}

const downloadTalentThemes = (startDate, endDate) => {
  const params = new URLSearchParams([
    ["start_date", startDate.toISOString()],
    ["end_date", endDate.toISOString()],
  ]);
  const url = `${BACKEND_URL}/api/v1/clifton-strengths/talent-themes/s/`;
  return axios.get(
    url,
    {
      params,
      responseType: "blob",
    },
  );
}

const createAssessmentReport = (reportId, templateId, content) => {
  const url = `${BACKEND_URL}/api/v1/clifton-strengths/assessment-reports/s/`;
  return axios.post(
    url,
    {
      report_id: reportId,
      template_id: templateId,
      content,
    },
    {
      responseType: "blob",
    },
  );
}

export const csServices = {
  listGuidance,
  updateGuidance,
  listReports,
  validateReport,
  retrieveReport,
  processReport,
  listAssessmentReportTemplates,
  createAssessmentReportPreview,
  downloadTalentThemes,
  createAssessmentReport,
};